export default __webpack_public_path__ + "static/media/LogoPAGE (2).a428a67b.png";